/**
 * Stop clicks on telephone links.
 *
 * @requires jQuery
 */

define('libs/components.tellinks',['require','jquery'],function(require) {

    'use strict';

    var $ = require('jquery');

    $(document.body).on('click', 'a[href^=tel]', function(event) {
        event.preventDefault();
    });

});

